import { useMemo, useState } from "react";

export const useProjectSlice = () => {
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedProjectIds, setSelectedProjectIds] = useState([]);

  return useMemo(() => ({ selectedProjects, setSelectedProjects, selectedProjectIds, setSelectedProjectIds }), [selectedProjects, selectedProjectIds]);
};
